import { CanvasLayer } from '@pdf-tools/four-heights-pdf-web-viewer/es6/modules/CanvasLayer';
import {
  Annotation,
  PdfItemType,

} from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-api';
import { imageDataUrlToUint8Array } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/Tools';
import { translationManager } from '@pdf-tools/four-heights-pdf-web-viewer/es6/common/TranslationManager';
import { createAddStampAnnotationToolbar } from '@pdf-tools/four-heights-pdf-web-viewer/es6/modules/stamp-annotation/AddStampAnnotationToolbar';
import { getRectFromSelection } from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-canvas/state/document';
import { CursorStyle } from '@pdf-tools/four-heights-pdf-web-viewer/es6/pdf-viewer-canvas/state/viewer';
import { AnnotationService } from '../annotation.service';
import { take } from 'rxjs/operators';

const moduleLayerName = 'CustomAddStampAnnotation';
export class CustomAddStampAnnotationLayer extends CanvasLayer {
  private context: any;
  private pointerDown;
  private startPoint: any;
  private stampRect: any;
  private page;
  private screenPageRect: any;
  private aspectRatio: any;
  private stamps: any[];

  constructor() {
    // @ts-ignore
    // eslint-disable-next-line prefer-rest-params
    super(...arguments);
    this.context = null;
    this.pointerDown = false;
    this.startPoint = null;
    this.stampRect = null;
    this.page = 0;
    this.screenPageRect = null;
    this.aspectRatio = null;
    this.stamps = [];
  }

  onCreate() {
    this.setStamp = this.setStamp.bind(this);
    this.close = this.close.bind(this);
    this.context = this.createCanvas();
    this.stamps = this.options.annotation.stamps;
    /* tslint:disable-next-line:align */
    // @ts-ignore
    const toolbarElement = this.module.toolbarElement;
    this.setStamp(this.options.annotation.selectedStamp);
    createAddStampAnnotationToolbar(
      {
        selectedStamp: this.options.annotation.selectedStamp,
        stamps: this.stamps,
        onStampChanged: this.setStamp,
        onClose: this.close,
      },
      toolbarElement
    );
    this.store.viewer.beginModule(moduleLayerName);
  }

  // @ts-ignore
  onSave() {
    const promise = new Promise<void>((resolve, reject) => {
      resolve();
    });
    return promise;
  }

  onRemove() {
    this.removeCanvasElements();
    this.context = null;
    /* tslint:disable-next-line:align */
    // @ts-ignore
    const toolbarElement = this.module.toolbarElement;
    toolbarElement.innerHTML = '';
    this.store.viewer.setCursorStyle(CursorStyle.DEFAULT);
    this.store.viewer.endModule(moduleLayerName);
  }

  render(timestamp: any, state: any) {
    if (state.viewer.modeChanged && state.viewer.selectedModuleName !== moduleLayerName) {
      this.remove();
      return;
    }
    if (!this.aspectRatio) {
      return;
    }
    if (this.context) {
      const update =
        state.viewer.modeChanged || state.pointer.positionChanged || state.pointer.action || state.document.zoomChanged;
      if (update) {
        const ctx = this.context;
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        const pointerPos = { x: state.pointer.x.devicePixels, y: state.pointer.y.devicePixels };
        const pointerPdfPos = this.pdfApi.transformScreenPointToPdfPoint(pointerPos);
        if (pointerPdfPos.isOnPage) {
          this.store.viewer.setCursorStyle(CursorStyle.CROSSHAIR);
        } else {
          this.store.viewer.setCursorStyle(CursorStyle.NOT_ALLOWED);
        }
        if (state.pointer.isDown) {
          if (!this.pointerDown) {
            if (!pointerPdfPos.isOnPage) {
              return;
            }
            this.startPoint = pointerPos;
            this.page = pointerPdfPos.pdfPoint.page;
            this.pointerDown = true;
            this.screenPageRect = this.pdfApi.getPageScreenRect(this.page);
          }
          if (this.startPoint && this.screenPageRect) {
            this.stampRect = getRectFromSelection(
              state.document,
              {
                x: this.startPoint.x,
                y: this.startPoint.y,
              },
              {
                x: pointerPos.x,
                y: pointerPos.y,
              }
            );
            if (this.stampRect) {
              this.stampRect.h = this.stampRect.w / this.aspectRatio;
              const lineWidth = 2 * devicePixelRatio;
              ctx.save();
              ctx.strokeStyle = this.options.viewer.general.textSelectionColor;
              ctx.fillStyle = this.options.viewer.general.textSelectionColor;
              ctx.lineWidth = lineWidth;
              ctx.setLineDash([lineWidth, lineWidth]);
              if (this.startPoint.y > pointerPos.y) {
                this.stampRect.y = this.startPoint.y - this.stampRect.h;
                if (this.stampRect.y < this.screenPageRect.y) {
                  this.stampRect.y = this.screenPageRect.y;
                  this.stampRect.w = this.stampRect.h * this.aspectRatio;
                }
              } else {
                if (this.startPoint.y + this.stampRect.h > this.screenPageRect.y + this.screenPageRect.h) {
                  this.stampRect.h = this.screenPageRect.y + this.screenPageRect.h - this.startPoint.y;
                  this.stampRect.w = this.stampRect.h * this.aspectRatio;
                }
              }
              ctx.strokeRect(this.stampRect.x, this.stampRect.y, this.stampRect.w, this.stampRect.h);
              ctx.globalAlpha = 0.33;
              ctx.fillRect(this.stampRect.x, this.stampRect.y, this.stampRect.w, this.stampRect.h);
              ctx.restore();
            }
          }
        } else if (this.pointerDown && this.startPoint) {
          if (this.stampRect) {
            this.createStampAnnotation(this.stampRect);
            this.pointerDown = false;
            this.startPoint = null;
            this.stampRect = null;
            this.page = 0;
            this.aspectRatio = null;
            this.screenPageRect = null;
            this.remove();
            return;
          }
        }
      }
    }
  }

  close() {
    this.remove();
  }

  setStamp(stampIndex: any) {
    if (this.stamps.length == 0) {
      return;
    }
    if (stampIndex >= this.stamps.length) {
      stampIndex = 0;
    }
    this.options.annotation.selectedStamp = stampIndex;

    const stamp = this.stamps[stampIndex];

    if (globalThis.__liveDokWeb__.annotationService) {
      globalThis.__liveDokWeb__.annotationService
        .getStampAspectRatio(stamp.text)
        .pipe(take(1))
        .subscribe((ratio) => {
          stamp.aspectRatio = ratio;
        });
    }

    // todo: handle pdf stamps
    if (stamp.aspectRatio) {
      this.aspectRatio = stamp.aspectRatio;
      return;
    }
    if (stamp.image) {
      const img = new Image();
      img.onload = () => {
        this.aspectRatio = img.width / img.height;
      };
      img.src = stamp.image;
      return;
    }
    this.pdfApi
      .getTextStampAspectRatio(stamp.text ? stamp.text : translationManager.getText(stamp.translation_key))
      .then((aspectRatio) => {
        this.aspectRatio = aspectRatio;
      });
  }

  createStampAnnotation(rect: any) {
    const pdfRect = this.pdfApi.transformScreenRectToPdfRect(rect, this.page);
    if (this.aspectRatio && (pdfRect.pdfW < 2 || pdfRect.pdfH < 2)) {
      switch (this.pdfApi.getRotation()) {
        case 0:
          pdfRect.pdfW = this.options.annotation.defaultStampWidth;
          pdfRect.pdfH = pdfRect.pdfW / this.aspectRatio;
          pdfRect.pdfY -= pdfRect.pdfH;
          break;
        case 90:
          pdfRect.pdfH = this.options.annotation.defaultStampWidth;
          pdfRect.pdfW = pdfRect.pdfH / this.aspectRatio;
          break;
        case 180:
          pdfRect.pdfW = this.options.annotation.defaultStampWidth;
          pdfRect.pdfH = pdfRect.pdfW / this.aspectRatio;
          pdfRect.pdfX -= pdfRect.pdfW;
          break;
        case 270:
          pdfRect.pdfH = this.options.annotation.defaultStampWidth;
          pdfRect.pdfW = pdfRect.pdfH / this.aspectRatio;
          pdfRect.pdfX -= pdfRect.pdfW;
          pdfRect.pdfY -= pdfRect.pdfH;
          break;
        default:
          break;
      }
    }
    const stampSetting = this.stamps[this.options.annotation.selectedStamp];

    if (!globalThis.__liveDokWeb__.annotationService) {
      return;
    }

    globalThis.__liveDokWeb__.annotationService
      .getStamp(stampSetting.text)
      .pipe(take(1))
      .subscribe((stampData) => {
        const imgData = imageDataUrlToUint8Array(stampData.imageData);
        this.pdfApi.registerStampImage(imgData).then((imageId) => {
          const annotation = {
            itemType: PdfItemType.STAMP,
            imageId,
            page: pdfRect.page,
            color: this.options.annotation.colors.defaultHighlightColor,
            pdfRect,
            author: stampData.author,
            subject: stampData.subject,
          };
          this.pdfApi.createItem(annotation).then((annot) => {
            this.onAnnotationCreated(<Annotation>annot);
          });
        });
      });
  }
}
